'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookConnectButton = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FacebookSDK = require('components/FacebookSDK/FacebookSDK');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookConnectButton = exports.FacebookConnectButton = function (_PureComponent) {
  (0, _inherits3.default)(FacebookConnectButton, _PureComponent);

  function FacebookConnectButton() {
    (0, _classCallCheck3.default)(this, FacebookConnectButton);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookConnectButton.__proto__ || (0, _getPrototypeOf2.default)(FacebookConnectButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookConnectButton, [{
    key: 'componentDidMount',

    /* istanbul ignore next */
    value: function componentDidMount() {
      var _this = this;

      if (__CLIENT__ && !window._fbAuthResponse) {
        // eslint-disable-line no-underscore-dangle
        this.facebookReadyHandler = function () {
          return _this.forceUpdate();
        };
        document.body.addEventListener('facebookReady', this.facebookReadyHandler);
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.facebookReadyHandler) {
        document.body.removeEventListener('facebookReady', this.facebookReadyHandler);
        this.facebookReadyHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = (0, _objectWithoutProperties3.default)(_props, ['children']);


      var disabled = rest.disabled || __SERVER__ || __CLIENT__ && !window._fbAuthResponse; // eslint-disable-line no-underscore-dangle

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_FacebookSDK.FacebookSDK, null),
        _react2.default.createElement(
          'button',
          (0, _extends3.default)({}, rest, {
            disabled: disabled
          }),
          children
        )
      );
    }
  }]);
  return FacebookConnectButton;
}(_react.PureComponent);

FacebookConnectButton.propTypes = {
  children: _propTypes2.default.node
};